export const translations = {
  // Navigation
  nav: {
    home: { en: 'Home', se: 'Hem' },
    services: { en: 'Services', se: 'Tjänster' },
    about: { en: 'About', se: 'Om Oss' },
    contact: { en: 'Contact', se: 'Kontakt' },
  },

  // Hero Section
  hero: {
    headline: { 
      en: 'Precision in Logistics & Marine Services', 
      se: 'Precision inom Logistik & Marina Tjänster' 
    },
    subheadline: { 
      en: 'Industrial, logistics and technical support services across the Nordic region', 
      se: 'Industriella, logistik- och tekniska stödtjänster i Norden' 
    },
    cta: { en: 'Our Services', se: 'Våra Tjänster' },
    ctaSecondary: { en: 'Contact Us', se: 'Kontakta Oss' },
  },

  // Services Overview
  servicesOverview: {
    title: { en: 'Our Services', se: 'Våra Tjänster' },
    industrial: {
      title: { en: 'Industrial & Logistics', se: 'Industri & Logistik' },
      description: { 
        en: 'Comprehensive support for industrial facilities and logistics operations', 
        se: 'Omfattande stöd för industriella anläggningar och logistikverksamhet' 
      },
    },
    marine: {
      title: { en: 'Marine & Technical', se: 'Marin & Teknisk' },
      description: { 
        en: 'Expert technical services for marine equipment and systems', 
        se: 'Expert tekniska tjänster för marin utrustning och system' 
      },
    },
  },

  // Value Props
  values: {
    reliability: {
      title: { en: 'Reliability', se: 'Pålitlighet' },
      description: { 
        en: 'Consistent, dependable service you can count on', 
        se: 'Konsekvent, pålitlig service du kan lita på' 
      },
    },
    expertise: {
      title: { en: 'Expertise', se: 'Expertis' },
      description: { 
        en: 'Skilled professionals with extensive industry experience', 
        se: 'Skickliga yrkesverksamma med omfattande branscherfarenhet' 
      },
    },
    support: {
      title: { en: 'Flexible Support', se: 'Flexibelt Stöd' },
      description: { 
        en: 'Adaptable solutions tailored to your operational needs', 
        se: 'Anpassningsbara lösningar skräddarsydda efter dina operativa behov' 
      },
    },
  },

  // CTA Section
  cta: {
    title: { en: 'Ready to optimize your operations?', se: 'Redo att optimera din verksamhet?' },
    button: { en: 'Get in Touch', se: 'Kontakta Oss' },
  },

  // Services Page
  servicesPage: {
    title: { en: 'Services', se: 'Tjänster' },
    subtitle: { 
      en: 'Comprehensive industrial, logistics and marine support', 
      se: 'Omfattande industriellt, logistik- och marint stöd' 
    },
    industrialTitle: { en: 'Industrial & Logistics Services', se: 'Industri & Logistiktjänster' },
    marineTitle: { en: 'Marine & Technical Services', se: 'Marin & Tekniska Tjänster' },
  },

  // Industrial Services
  industrialServices: {
    transportation: {
      title: { en: 'Transportation', se: 'Transport' },
      description: { 
        en: 'Cargo transportation and fleet coordination for industrial operations', 
        se: 'Godstransport och flottsamordning för industriell verksamhet' 
      },
    },
    facilitySupport: {
      title: { en: 'Facility Support', se: 'Anläggningsstöd' },
      description: { 
        en: 'Industrial site support, operational assistance and facility management', 
        se: 'Industriellt platsstöd, operativ assistans och anläggningshantering' 
      },
    },
    construction: {
      title: { en: 'Construction & Renovation', se: 'Konstruktion & Renovering' },
      description: { 
        en: 'Industrial renovation support, facility upgrades and site preparation', 
        se: 'Industriellt renoveringsstöd, anläggningsuppgraderingar och platsförberedelse' 
      },
    },
    warehouse: {
      title: { en: 'Warehouse & Logistics', se: 'Lager & Logistik' },
      description: { 
        en: 'Warehouse operations, goods handling and logistics coordination', 
        se: 'Lagerverksamhet, godshantering och logistiksamordning' 
      },
    },
  },

  // Marine Services
  marineServices: {
    maintenance: {
      title: { en: 'Marine Maintenance & Repair', se: 'Marin Underhåll & Reparation' },
      description: { 
        en: 'Equipment maintenance, mechanical repairs and on-site technical service', 
        se: 'Utrustningsunderhåll, mekaniska reparationer och teknisk service på plats' 
      },
    },
    inspection: {
      title: { en: 'Hose & Heat Exchanger Inspection', se: 'Slang & Värmeväxlarinspektion' },
      description: { 
        en: 'Inspection services, pressure testing and system cleaning', 
        se: 'Inspektionstjänster, trycktestning och systemrengöring' 
      },
    },
    cleaning: {
      title: { en: 'Industrial Cleaning', se: 'Industriell Rengöring' },
      description: { 
        en: 'Technical cleaning, filtration and equipment flushing', 
        se: 'Teknisk rengöring, filtrering och utrustningsspolning' 
      },
    },
    pump: {
      title: { en: 'Pump Repair', se: 'Pumpreparation' },
      description: { 
        en: 'Pump servicing and mechanical repair solutions', 
        se: 'Pumpservice och mekaniska reparationslösningar' 
      },
    },
    manifold: {
      title: { en: 'Custom Manifold Systems', se: 'Anpassade Manifoldsystem' },
      description: { 
        en: 'Design, fabrication and custom industrial solutions', 
        se: 'Design, tillverkning och anpassade industriella lösningar' 
      },
    },
    hvac: {
      title: { en: 'HVAC Service', se: 'VVS-Service' },
      description: { 
        en: 'Ventilation and cooling systems technical service', 
        se: 'Ventilation och kylsystem teknisk service' 
      },
    },
    refurbishment: {
      title: { en: 'Equipment Refurbishment', se: 'Utrustningsrenovering' },
      description: { 
        en: 'Equipment removal, sandblasting and restoration', 
        se: 'Utrustningsborttagning, sandblästring och restaurering' 
      },
    },
  },

  // About Page
  aboutPage: {
    title: { en: 'About Natcas Group', se: 'Om Natcas Group' },
    subtitle: { 
      en: 'Professional support for industrial operations across the Nordic region', 
      se: 'Professionellt stöd för industriell verksamhet i Norden' 
    },
    story: {
      title: { en: 'Who We Are', se: 'Vilka Vi Är' },
      content: { 
        en: 'Natcas Group provides professional support services for industrial operations, logistics environments and technical equipment across the Nordic region. The company focuses on delivering practical solutions that support efficient operations and long-term reliability. Our approach is based on professionalism, flexibility and technical expertise.', 
        se: 'Natcas Group tillhandahåller professionella stödtjänster för industriell verksamhet, logistikmiljöer och teknisk utrustning i hela Norden. Företaget fokuserar på att leverera praktiska lösningar som stödjer effektiv drift och långsiktig tillförlitlighet. Vårt tillvägagångssätt bygger på professionalism, flexibilitet och teknisk expertis.' 
      },
    },
    values: {
      title: { en: 'Our Values', se: 'Våra Värderingar' },
      professionalism: {
        title: { en: 'Professionalism', se: 'Professionalism' },
        description: { 
          en: 'We maintain the highest standards in everything we do', 
          se: 'Vi upprätthåller högsta standard i allt vi gör' 
        },
      },
      flexibility: {
        title: { en: 'Flexibility', se: 'Flexibilitet' },
        description: { 
          en: 'Adaptable solutions for diverse operational needs', 
          se: 'Anpassningsbara lösningar för olika operativa behov' 
        },
      },
      experience: {
        title: { en: 'Experience', se: 'Erfarenhet' },
        description: { 
          en: 'Years of operational expertise across industries', 
          se: 'År av operativ expertis inom olika branscher' 
        },
      },
    },
  },

  // Contact Page
  contactPage: {
    title: { en: 'Contact Us', se: 'Kontakta Oss' },
    subtitle: { 
      en: 'Get in touch with our team', 
      se: 'Ta kontakt med vårt team' 
    },
    form: {
      name: { en: 'Name', se: 'Namn' },
      namePlaceholder: { en: 'Your name', se: 'Ditt namn' },
      email: { en: 'Email', se: 'E-post' },
      emailPlaceholder: { en: 'your@email.com', se: 'din@email.com' },
      message: { en: 'Message', se: 'Meddelande' },
      messagePlaceholder: { en: 'How can we help you?', se: 'Hur kan vi hjälpa dig?' },
      submit: { en: 'Send Message', se: 'Skicka Meddelande' },
      sending: { en: 'Sending...', se: 'Skickar...' },
      success: { en: 'Message sent successfully!', se: 'Meddelandet skickades!' },
      error: { en: 'Failed to send message. Please try again.', se: 'Kunde inte skicka meddelandet. Försök igen.' },
    },
    info: {
      title: { en: 'Contact Information', se: 'Kontaktinformation' },
      email: { en: 'Email', se: 'E-post' },
      hours: { en: 'Opening Hours', se: 'Öppettider' },
      hoursValue: { en: 'Monday – Friday: 08:00 – 16:00', se: 'Måndag – Fredag: 08:00 – 16:00' },
      region: { en: 'Service Region', se: 'Tjänsteregion' },
      regionValue: { en: 'Nordic Region', se: 'Norden' },
    },
  },

  // Footer
  footer: {
    tagline: { 
      en: 'Industrial, logistics and technical support services across the Nordic region', 
      se: 'Industriella, logistik- och tekniska stödtjänster i Norden' 
    },
    quickLinks: { en: 'Quick Links', se: 'Snabblänkar' },
    contact: { en: 'Contact', se: 'Kontakt' },
    copyright: { 
      en: '© 2026 Natcas Group. All rights reserved.', 
      se: '© 2026 Natcas Group. Alla rättigheter förbehållna.' 
    },
  },
};
